import * as React from 'react';
import { DropdownItem } from 'ui/common/dropdown-menu/dropdown-menu-item';
import { ExpandableBox } from '../../../components/expandable-box';
import { isPositiveNumeric } from 'app/infrastructure/data/number';
import styles from './distribution-field.scss';
import { DistributionPanelTexts } from './distribution-panel-texts';
import { ComplexValue } from 'ui';
import { FieldItem } from 'app/area/reports/types';

import type { JSX } from "react";

interface DistributionFieldComponentProps {
  onUpdateField: (exposureApplication: FieldItem, exposureFactor?: number, exposurePercent?: number) => void;
  translation: DistributionPanelTexts;
  selectedExposureApplication: ComplexValue<number>;
  selectedExposureFactor: number;
  selectedExposurePercent: number;
}

class DistributionFieldComponent extends React.Component<DistributionFieldComponentProps, {}> {
  private menuItemsForAggregation = (): DropdownItem[] => {
    const handleOnRemove = () => {
      this.props.onUpdateField(undefined);
    };
    return [{
      value: '1',
      description: this.props.translation.distribution_remove,
      onClick: handleOnRemove
    }];
  };

  private handleChangeForEvery = (e: React.SyntheticEvent<HTMLInputElement>) => {
    const {
      selectedExposureApplication,
      selectedExposureFactor,
      selectedExposurePercent,
      onUpdateField
    } = this.props;

    const { value } = e.currentTarget;
    let nextValue = selectedExposureFactor;

    if (isPositiveNumeric(value)) {
      nextValue = parseInt(value, 10);
    } else if (typeof value === 'string' && value.trim() === '') {
      nextValue = undefined;
    }

    onUpdateField(selectedExposureApplication, nextValue, selectedExposurePercent);
  };

  private handleChangePercentIncrease = (e: React.SyntheticEvent<HTMLInputElement>) => {
    const {
      selectedExposureApplication,
      selectedExposureFactor,
      selectedExposurePercent,
      onUpdateField
    } = this.props;

    const { value } = e.currentTarget;
    let nextValue = selectedExposurePercent;

    if (isPositiveNumeric(value)) {
      nextValue = parseInt(value, 10);
    } else if (typeof value === 'string' && value.trim() === '') {
      nextValue = undefined;
    }

    onUpdateField(selectedExposureApplication, selectedExposureFactor, nextValue);
  };

  public render(): JSX.Element {
    const {
      selectedExposureApplication,
      selectedExposureFactor,
      selectedExposurePercent,
      translation
    } = this.props;

    return (<ExpandableBox title={selectedExposureApplication.description}
      menuItems={this.menuItemsForAggregation()}>
      <div className={styles.panel}>
        <label htmlFor="forEvery" className="control-label">
          {translation.distribution_for_every}
        </label>
        <div className="input-wrapper">
          <input 
            id="forEvery" 
            type="text" 
            onChange={this.handleChangeForEvery}
            value={selectedExposureFactor}
            maxLength={9}
            className="form-control"
          />
        </div>
        <label htmlFor="percentIncrease" className="control-label">
          {translation.distribution_percent_inrease}
        </label>
        <div className="input-wrapper">
          <input 
            id="percentIncrease" 
            type="text"
            onChange={this.handleChangePercentIncrease}
            value={selectedExposurePercent}
            maxLength={3}
            className="form-control"
          />
          </div>
      </div>
    </ExpandableBox>);
  }
}

export const DistributionField = DistributionFieldComponent;
